window.addEventListener('DOMContentLoaded', () => {
  const dropdowns = document.querySelectorAll('.dropdown');
  const dropdownsHolders = document.querySelectorAll('.dropdownHolder');
  const dropdownsButtons = document.querySelectorAll('.dropdownValue');

  const closeDropdown = () => {
    dropdowns.forEach(item => {
      item.classList.remove('dropdown--visible');
    });

    dropdownsHolders.forEach(item => {
      item.classList.remove('dropdownHolder--active');
    });

    dropdownsButtons.forEach(item => {
      item.classList.remove('dropdownValue--active');
    });
  };

  document.addEventListener('click', event => {
    const isDropdownButton =
      event.target.classList.contains('dropdownValue') || event.target.closest('.dropdownValue');
    const isDropdownSection = event.target.classList.contains('dropdownSelection');

    if (isDropdownButton) {
      const dropdownButton = event.target.closest('.dropdownValue');
      const dropdown = dropdownButton.nextElementSibling;
      const dropdownHolder = dropdownButton.closest('.dropdownHolder');

      dropdown?.classList.toggle('dropdown--visible');
      dropdownHolder?.classList.toggle('dropdownHolder--active');
      dropdownButton?.classList.toggle('dropdownValue--active');
    }

    if (!isDropdownButton && !isDropdownSection) {
      closeDropdown();
    }
  });
});
